const PrivacyPolicy = () => {
  return (
    <div className="y-wrap y-wrap--inner">
      <div className="content-block">
        <h1>Privacy Policy</h1>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
